import type { ResolutionString } from 'charting_library';

const INTERVAL_MAP: Record<string, string> = {
  '1': '60',
  '5': '300',
  '15': '900',
  '30': '1800',
  '60': '3600',
  '120': '7200',
  '240': '14400',
  '480': '28800',
  '720': '43200',
  '1D': '86400',
};

const REVERSE_MAP = Object.fromEntries(Object.entries(INTERVAL_MAP).map(([k, v]) => [v, k]));

export class DexIntervalMapper {
  getExchangeInterval(resolution: string): string | undefined {
    return INTERVAL_MAP[resolution];
  }

  getResolutionFromInterval(interval: string): ResolutionString {
    return (REVERSE_MAP[interval] || '1D') as ResolutionString;
  }

  getSupportedResolutions(): ResolutionString[] {
    return Object.keys(INTERVAL_MAP) as ResolutionString[];
  }
}
